import styled from 'styled-components';

export const StyledTrademark = styled.div`
  width: 320px;
  margin: 0 auto;
  text-align: center;
  padding: 20px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_80};
`;

export default {};
